<template>
    <div>
        <a-table size="small" :pagination="false"
            :columns="columns" :data-source="submissions" rowKey="id"
        >
            <verdict-icon slot="verify" slot-scope="verify" :verify="verify" />
            <template slot="user" slot-scope="user">
                <user-link v-if="user.id > 0" :id="user.id" :name="user.name" />
                <span v-else>{{ user.name }}</span>
            </template>
            <a class="tower-title" slot="name" slot-scope="title, record" :href="`/games/${ record.name }`" target="_blank">{{ title }}</a>
            <span slot="timestamp" slot-scope="timestamp">{{ formatDate(timestamp)}}</span>
        </a-table>
    </div>
</template>

<script>
import VerdictIcon from '@/components/VerdictIcon.vue'
import UserLink from '@/components/UserLink.vue';

export default {
    props: {
        submissions: Array,
    },
    data: () => ({
        columns: [
            { dataIndex: 'verify', slot: 'verify' },
            { title: '用户名', dataIndex: 'user', slot: 'user' },
            { title: '分数', dataIndex: 'score' },
            { title: '游戏时间', dataIndex: 'totalTime' },
            { title: '提交时间', dataIndex: 'timestamp', slot: 'timestamp' },
        ].map(e => e.slot ? { ...e, scopedSlots: { customRender: e.slot } } : e )
    }),
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
    },
    components: {
        VerdictIcon,
        UserLink,
    }
}
</script>

<style>

</style>